// src/components/issues/LigneCompacte.tsx — SCE Issues
// Rangée cliquable pour les listes INTERNES aux fiches détail.
//
// ─── Pourquoi pas IssueRow ni ListeProblemesTelephone ───
//
// IssueRow suppose la colonne de contenu de 728px : son gabarit fixe déborde
// dans une modale, plafonnée à 640px (--width-modal). ListeProblemesTelephone, à l'inverse,
// est trop haute pour une liste secondaire nichée dans une fiche.
//
// Cette rangée-ci est volontairement pauvre : deux lignes de texte, un état à
// droite. Elle sert les listes qu'on parcourt du coin de l'œil à l'intérieur
// d'une fiche — les équipements d'un projet, les problèmes d'un équipement —
// pas les listes principales de l'application.

import type { ReactNode } from 'react'

export function LigneCompacte({
  titre,
  sousTitre,
  droite,
  couleurDroite,
  onClick,
}: {
  titre: ReactNode
  sousTitre?: ReactNode
  /** Valeur d'état alignée à droite (statut, compteur…). */
  droite?: ReactNode
  couleurDroite?: string
  onClick: () => void
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-between gap-3 w-full text-left"
      style={{
        backgroundColor: 'var(--color-bg-card)',
        border: '1px solid var(--color-border)',
        borderRadius: 10,
        padding: '10px 14px',
        cursor: 'pointer',
      }}
    >
      <div className="min-w-0">
        <div
          className="truncate"
          style={{ fontSize: 'var(--font-size-copy2)', fontWeight: 600 }}
        >
          {titre}
        </div>
        {sousTitre !== undefined && (
          <div
            className="truncate"
            style={{
              fontSize: 'var(--font-size-info)',
              color: 'var(--color-text-secondary)',
              marginTop: 2,
            }}
          >
            {sousTitre}
          </div>
        )}
      </div>

      {droite !== undefined && (
        <span
          style={{
            flexShrink: 0,
            fontSize: 'var(--font-size-info)',
            fontWeight: 600,
            color: couleurDroite ?? 'var(--color-text-secondary)',
          }}
        >
          {droite}
        </span>
      )}
    </button>
  )
}

// ─── Titre de section, commun aux fiches ───

export function TitreSection({
  children,
  compteur,
}: {
  children: ReactNode
  compteur?: number
}): JSX.Element {
  return (
    <h3
      style={{
        fontSize: 'var(--font-size-copy2)',
        fontWeight: 600,
        color: 'var(--color-text-primary)',
        margin: '4px 0 10px',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
      }}
    >
      {children}
      {compteur !== undefined && compteur > 0 && ` (${compteur})`}
    </h3>
  )
}

// ─── État vide ───

export function EtatVide({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div
      className="text-center py-6 rounded"
      style={{
        backgroundColor: 'var(--color-bg-card)',
        border: '1px solid var(--color-border)',
        color: 'var(--color-text-secondary)',
        fontSize: 'var(--font-size-copy2)',
      }}
    >
      {children}
    </div>
  )
}
